export default {
  erreurCreationRecommandation: 'Erreur lors de création de la recommandation',
  erreurRecuperationProduitsFace: 'Erreur lors de la récupération des produits face',
  erreurRecuperationSurfaceOccupee: 'Erreur lors de la récupération de la surface déjà occupée sur la face',
  erreurCreationPanneau: 'Erreur lors de la création d\'un panneau',
  errorRecuperationRecom: 'Erreur lors de la récupération de la recommandation id: {recomId}'
}
